import { render, staticRenderFns } from "./DoctorCreate.vue?vue&type=template&id=502c63f5&"
import script from "./DoctorCreate.vue?vue&type=script&lang=js&"
export * from "./DoctorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports